export enum HttpMethod {
  get = 0,
  post = 1,
  put = 2,
  delete = 3,
  patch = 4,
  head = 5,
  trace = 6,
  options = 7,
  connect = 8,
}
